module.exports = __webpack_public_path__ + "static/media/weixin-mass.ea13b740.png";